import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./validator";

import { FormField } from "../../../ui-kit/FormField/FormField";
import { IButton } from "../../../ui-kit/IButton/IButton";
import Api from "../../../api/Auth";
import DefectRegister from "../../../store/defectRegister";
import { useHistory, Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import classnames from "classnames";
import defectRegister from "../../../store/defectRegister";
import { authStore } from "../../../store/authStore";
import ApiUrls from "../../../constants/ApiUrls";
import { LogoDarkLetters } from "../../../assets/customIcons";
import ApiSupport from "../../../modules/Admin/System/Loginpage/LoginPageApi";
import { loginStore } from "../../../modules/Admin/System/Loginpage/LoginpageStore";
import styles from "./LoginForm.module.scss";

export interface ILoginForm {
  userName: string;
  password: string;
}

export const LoginForm: React.FC = observer(() => {
  const [isFocused, setIsFocused] = useState({
    userName: false,
    password: false,
  });

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ILoginForm>({ resolver: yupResolver(schema) });

  const watchAllField = watch();

  const history = useHistory();
  const { authFormsIsLoading, messageLogout } = authStore;

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setIsFocused({ ...isFocused, [name]: true });
    if (messageLogout) {
      authStore.clearMessageLogout();
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;

    if (watchAllField[name] !== "") {
      setIsFocused({ ...isFocused, [name]: true });
    } else {
      setIsFocused({ ...isFocused, [name]: false });
    }
  };

  const onSubmit = async (data: ILoginForm) => {
    await authStore.login(data, history);
    await authStore.getUserInfo(history);
  };

  const loginEsia = async () => {
    location.assign(ApiUrls.authUrl + "/auth/esia/login");
    reset();
  };

  const errorMessage = (msg: string, field: string) => {
    if (msg) {
      return msg;
    }

    if (authStore?.loginError) {
      if (field === "userName") {
        return true;
      }
      if (field === "password") {
        return authStore?.loginError;
      }
    }
  };
  useEffect(() => {
    loginStore.getContactLogin();
  }, []);

  return (
    <div className={styles.positioning}>
      {/* <LogoDarkLetters className={styles.positioning__svg} /> */}

      <div className={styles.wrapper}>
        <div className={!!messageLogout ? styles.message : styles.message_off}>
          {messageLogout}
        </div>
        <div className={styles.header}>
          <h1 className={styles.title}>Авторизация</h1>
        </div>
        <form
          id="submit"
          className={styles.form}
          onSubmit={handleSubmit(onSubmit)}
        >
          <FormField
            label="Логин"
            name="userName"
            register={register}
            type="text"
            error={errorMessage(errors?.userName?.message, "userName")}
            isFocused={isFocused.userName}
            onFocus={handleFocus}
            onBlur={handleBlur}
            currentValue={watchAllField.userName}
            autocomplete="on"
            isRequired
          />
          <FormField
            className={styles.password}
            label="Пароль"
            name="password"
            register={register}
            type="password"
            error={errorMessage(errors?.password?.message, "password")}
            isFocused={isFocused.password}
            onFocus={handleFocus}
            onBlur={handleBlur}
            currentValue={watchAllField.password}
            autocomplete="on"
            isRequired
          />

          <Link
            to="/reset-password"
            className={classnames(styles.link, {
              [styles.link_show]: errorMessage(
                errors?.password?.message,
                "password",
              ),
            })}
          >
            Забыли пароль?
          </Link>
        </form>
        <div className={styles.footer}>
          <IButton
            form="submit"
            type="submit"
            disabled={authFormsIsLoading.value}
          >
            Войти
          </IButton>
        </div>
        <div className={styles.support__footer}>
          {loginStore.supportAddress}
        </div>
      </div>
    </div>
  );
});
